var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#289E48"
    },
    d: "M224.323,20.893c0-0.443,0.073-0.865,0.177-1.276h-1.517c-89.511,0-162.333,72.775-162.333,162.232 V311h30.265V181.848c0-72.893,59.129-131.986,132.068-131.986h1.34V20.893z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#289E48"
    },
    d: "M289.017,19.616h-1.519c0.104,0.411,0.177,0.833,0.177,1.276v28.969h1.342 c72.94,0,132.068,59.094,132.068,131.986V311h30.265V181.848C451.35,92.392,378.528,19.616,289.017,19.616z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD4B2"
    },
    d: "M146.498,228.125c-0.121-0.433-0.206-0.88-0.206-1.35V207.1c0-2.805,2.296-5.1,5.102-5.1h63.786 v-86.956c0-3.52-2.88-6.398-6.401-6.398H89.69c-3.521,0-6.402,2.879-6.402,6.398v113.081H146.498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9F3D"
    },
    d: "M150.649,108.646H89.69c-3.521,0-6.402,2.879-6.402,6.398v60.921L150.649,108.646z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E004C"
    },
    d: "M105.739,228.125V115.044c0-3.52,2.88-6.398,6.402-6.398H89.69c-3.521,0-6.402,2.879-6.402,6.398 v113.081H105.739z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M146.498,228.125c-0.121-0.433-0.206-0.88-0.206-1.35V207.1c0-2.805,2.296-5.1,5.102-5.1h22.17 v-7.391c0-13.43-10.892-24.314-24.33-24.314c-13.437,0-24.33,10.885-24.33,24.314v33.516H146.498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#463F8E"
    },
    d: "M428.518,162.261V73.537c-0.728,0.402-1.553,0.652-2.44,0.652h-35.057 c-0.888,0-1.712-0.25-2.441-0.652v88.724c-24.696,2.654-43.929,23.547-43.929,48.934V251h127.798v-39.806 C472.449,185.808,453.217,164.915,428.518,162.261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#1E004C",
      enableBackground: "new"
    },
    d: "M391.022,74.189c-0.888,0-1.712-0.25-2.441-0.652v88.724 c-24.696,2.654-43.929,23.547-43.929,48.934V251h16.225v-29.22c0-22.595,16.926-41.452,39.372-43.864 c2.592-0.278,4.557-2.465,4.557-5.07V74.189H391.022z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.65,
    y: 248.45,
    style: {
      fill: "#FFB889"
    },
    width: 127.8,
    height: 62.55
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.65,
    y: 272.39,
    style: {
      fill: "#FFD4B2"
    },
    width: 127.8,
    height: 38.607
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA9F75"
    },
    d: "M431.181,71.724c0,2.805-2.296,5.1-5.103,5.1h-35.057c-2.807,0-5.103-2.295-5.103-5.1v-54.99 c0-2.805,2.296-5.1,5.103-5.1h35.057c2.807,0,5.103,2.295,5.103,5.1V71.724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#1E004C",
      enableBackground: "new"
    },
    d: "M404.992,71.724v-54.99c0-2.805,2.296-5.1,5.102-5.1h-19.073 c-2.807,0-5.103,2.295-5.103,5.1v54.99c0,2.805,2.296,5.1,5.103,5.1h19.073C407.288,76.823,404.992,74.528,404.992,71.724z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFBB4A"
    },
    cx: 408.55,
    cy: 255.1,
    rx: 31.949,
    ry: 31.93
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBB4A"
    },
    d: "M169.621,311v-28.622c0-19.037-15.442-34.47-34.491-34.47H82.244 c-19.048,0-34.49,15.433-34.49,34.47V311H169.621z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E004C"
    },
    d: "M69.841,311v-28.622c0-19.037,15.442-34.47,34.491-34.47H82.244c-19.048,0-34.49,15.433-34.49,34.47 V311H69.841z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E5E5"
    },
    d: "M171.921,250.9c0,2.805-2.296,5.1-5.102,5.1H50.556c-2.806,0-5.103-2.295-5.103-5.1v-19.676 c0-2.805,2.296-5.1,5.103-5.1h116.262c2.806,0,5.102,2.295,5.102,5.1V250.9H171.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#1E004C",
      enableBackground: "new"
    },
    d: "M78.508,250.9v-19.676c0-2.805,2.296-5.1,5.102-5.1H50.556 c-2.806,0-5.103,2.295-5.103,5.1V250.9c0,2.805,2.296,5.1,5.103,5.1H83.61C80.804,256,78.508,253.705,78.508,250.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M138.838,311c-4.516-15.506-16.31-26.566-30.151-26.566S83.051,295.495,78.536,311H138.838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB786E"
    },
    d: "M378.127,311v-28.622c0-19.037-15.443-34.47-34.492-34.47h-52.886 c-19.049,0-34.49,15.433-34.49,34.47V311H378.127z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E004C"
    },
    d: "M284.145,311v-28.622c0-19.037,15.44-34.47,34.489-34.47h-27.886 c-19.049,0-34.49,15.433-34.49,34.47V311H284.145z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E5E5"
    },
    d: "M380.427,250.9c0,2.805-2.296,5.1-5.103,5.1H259.061c-2.807,0-5.102-2.295-5.102-5.1v-19.676 c0-2.805,2.296-5.1,5.102-5.1h116.263c2.807,0,5.103,2.295,5.103,5.1V250.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#1E004C",
      enableBackground: "new"
    },
    d: "M287.636,250.9v-19.676c0-2.805,2.296-5.1,5.103-5.1h-33.677 c-2.807,0-5.102,2.295-5.102,5.1V250.9c0,2.805,2.296,5.1,5.102,5.1h33.677C289.932,256,287.636,253.705,287.636,250.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M347.344,311c-4.516-15.506-16.312-26.566-30.152-26.566s-25.635,11.061-30.15,26.566H347.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#775436"
    },
    d: "M267.913,311v-52.73c0-19.037-15.442-34.47-34.491-34.47h-52.886 c-19.048,0-34.491,15.433-34.491,34.47V311H267.913z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E004C"
    },
    d: "M168.237,311v-52.73c0-19.037,15.442-34.47,34.491-34.47h-22.192 c-19.048,0-34.491,15.433-34.491,34.47V311H168.237z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E5E5"
    },
    d: "M270.213,224.775c0,2.805-2.296,5.1-5.103,5.1H148.848c-2.807,0-5.102-2.295-5.102-5.1V205.1 c0-2.805,2.296-5.1,5.102-5.1H265.11c2.807,0,5.103,2.295,5.103,5.1L270.213,224.775L270.213,224.775z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#1E004C",
      enableBackground: "new"
    },
    d: "M171.373,224.775V205.1c0-2.805,2.296-5.1,5.102-5.1h-27.627 c-2.807,0-5.102,2.295-5.102,5.1v19.676c0,2.805,2.296,5.1,5.102,5.1h27.627C173.669,229.875,171.373,227.58,171.373,224.775z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M238.094,311c0.655-3.228,1.003-6.612,1.003-10.099c0-22.408-14.379-40.576-32.118-40.576 s-32.119,18.168-32.119,40.576c0,3.486,0.349,6.87,1.003,10.099H238.094z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C73627"
    },
    d: "M34.236,346l32.083,160.998c0.548,2.751,3.293,5.002,6.099,5.002h367.164 c2.807,0,5.552-2.251,6.1-5.002L477.764,346H34.236z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF5A50"
    },
    d: "M96.494,391.646H76.042c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h20.452 c4.142,0,7.5,3.357,7.5,7.5C103.994,388.288,100.636,391.646,96.494,391.646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF5A50"
    },
    d: "M96.494,476.791H76.042c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h20.452 c4.142,0,7.5,3.357,7.5,7.5S100.636,476.791,96.494,476.791z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#1E004C",
      enableBackground: "new"
    },
    d: "M102.169,506.998L70.086,346h-35.85l32.083,160.998 c0.548,2.751,3.293,5.002,6.099,5.002h35.85C105.461,512,102.717,509.749,102.169,506.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#289E48"
    },
    d: "M495.621,343.126c0,2.805-2.296,5.1-5.103,5.1H21.481c-2.806,0-5.102-2.295-5.102-5.1v-29.713 c0-2.805,2.296-5.1,5.102-5.1h469.037c2.807,0,5.103,2.295,5.103,5.1V343.126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#1E004C",
      enableBackground: "new"
    },
    d: "M66.579,343.126v-29.713c0-2.805,2.296-5.1,5.103-5.1h-50.2 c-2.806,0-5.102,2.295-5.102,5.1v29.713c0,2.805,2.296,5.1,5.102,5.1h50.2C68.874,348.226,66.579,345.931,66.579,343.126z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#82E89B"
    },
    points: "310.01,348.226 331.227,348.226 371.149,308.314 349.934,308.314  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#82E89B"
    },
    points: "366.757,348.226 387.973,348.226 427.897,308.314 406.681,308.314  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#82E89B"
    },
    points: "423.505,348.226 444.721,348.226 484.644,308.314 463.428,308.314  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#82E89B"
    },
    points: "196.143,348.226 217.359,348.226 257.282,308.314 236.066,308.314  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#82E89B"
    },
    points: "252.89,348.226 274.105,348.226 314.029,308.314 292.813,308.314  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#82E89B"
    },
    points: "82.276,348.226 103.492,348.226 143.415,308.314 122.199,308.314  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#82E89B"
    },
    points: "139.022,348.226 160.238,348.226 200.162,308.314 178.947,308.314  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#82E89B"
    },
    points: "25.155,348.226 46.371,348.226 86.295,308.314 65.08,308.314  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF5A50"
    },
    d: "M164.387,391.646h-20.452c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h20.452 c4.142,0,7.5,3.357,7.5,7.5C171.887,388.288,168.529,391.646,164.387,391.646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF5A50"
    },
    d: "M232.28,391.646h-20.452c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h20.452 c4.142,0,7.5,3.357,7.5,7.5C239.78,388.288,236.422,391.646,232.28,391.646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF5A50"
    },
    d: "M300.172,391.646h-20.451c-4.143,0-7.5-3.357-7.5-7.5s3.357-7.5,7.5-7.5h20.451 c4.143,0,7.5,3.357,7.5,7.5C307.672,388.288,304.315,391.646,300.172,391.646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF5A50"
    },
    d: "M368.065,391.646h-20.452c-4.143,0-7.5-3.357-7.5-7.5s3.357-7.5,7.5-7.5h20.452 c4.143,0,7.5,3.357,7.5,7.5C375.565,388.288,372.208,391.646,368.065,391.646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF5A50"
    },
    d: "M435.958,391.646h-20.453c-4.143,0-7.5-3.357-7.5-7.5s3.357-7.5,7.5-7.5h20.453 c4.143,0,7.5,3.357,7.5,7.5C443.458,388.288,440.101,391.646,435.958,391.646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF5A50"
    },
    d: "M130.441,436.88h-20.453c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h20.453 c4.142,0,7.5,3.357,7.5,7.5C137.941,433.522,134.583,436.88,130.441,436.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF5A50"
    },
    d: "M198.333,436.88h-20.452c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h20.452 c4.142,0,7.5,3.357,7.5,7.5C205.833,433.522,202.475,436.88,198.333,436.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF5A50"
    },
    d: "M266.226,436.88h-20.451c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h20.451 c4.143,0,7.5,3.357,7.5,7.5C273.726,433.522,270.368,436.88,266.226,436.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF5A50"
    },
    d: "M334.119,436.88h-20.452c-4.143,0-7.5-3.357-7.5-7.5s3.357-7.5,7.5-7.5h20.452 c4.143,0,7.5,3.357,7.5,7.5C341.619,433.522,338.262,436.88,334.119,436.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF5A50"
    },
    d: "M402.012,436.88h-20.453c-4.143,0-7.5-3.357-7.5-7.5s3.357-7.5,7.5-7.5h20.453 c4.143,0,7.5,3.357,7.5,7.5C409.512,433.522,406.154,436.88,402.012,436.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF5A50"
    },
    d: "M164.387,476.791h-20.452c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h20.452 c4.142,0,7.5,3.357,7.5,7.5S168.529,476.791,164.387,476.791z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF5A50"
    },
    d: "M232.28,476.791h-20.452c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h20.452 c4.142,0,7.5,3.357,7.5,7.5S236.422,476.791,232.28,476.791z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF5A50"
    },
    d: "M300.172,476.791h-20.451c-4.143,0-7.5-3.357-7.5-7.5s3.357-7.5,7.5-7.5h20.451 c4.143,0,7.5,3.357,7.5,7.5S304.315,476.791,300.172,476.791z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF5A50"
    },
    d: "M368.065,476.791h-20.452c-4.143,0-7.5-3.357-7.5-7.5s3.357-7.5,7.5-7.5h20.452 c4.143,0,7.5,3.357,7.5,7.5S372.208,476.791,368.065,476.791z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF5A50"
    },
    d: "M435.958,476.791h-20.453c-4.143,0-7.5-3.357-7.5-7.5s3.357-7.5,7.5-7.5h20.453 c4.143,0,7.5,3.357,7.5,7.5S440.101,476.791,435.958,476.791z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF5A50"
    },
    d: "M228.425,56.616c-2.806,0-5.103-2.295-5.103-5.1V28.935l-71.361,71.78 c-1.186,1.193-0.804,2.428,0.85,2.741l17.95,3.404c1.654,0.313,3.261,1.925,3.571,3.579l3.388,18.088 c0.31,1.653,1.534,2.029,2.721,0.837l72.33-72.749h-24.346V56.616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF5A50"
    },
    d: "M360.039,100.716l-71.364-71.782v22.583c0,2.805-2.296,5.1-5.102,5.1h-24.339l72.322,72.747 c1.187,1.192,2.411,0.816,2.721-0.837l3.386-18.093c0.311-1.654,1.917-3.265,3.571-3.577l17.955-3.4 C360.843,103.144,361.226,101.909,360.039,100.716z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C73627"
    },
    d: "M224.323,51.517V20.893c0-1.029,0.305-1.987,0.819-2.791L213.824,3.98 C212.07,1.791,208.339,0,205.532,0h-47.821c-2.806,0-5.103,2.295-5.103,5.1v62.213c0,2.805,2.296,5.1,5.103,5.1h47.821 c2.807,0,6.538-1.791,8.292-3.979l11.318-14.124C224.627,53.505,224.323,52.547,224.323,51.517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#1E004C",
      enableBackground: "new"
    },
    d: "M174.915,67.313V5.1c0-2.805,2.296-5.1,5.103-5.1h-22.307 c-2.806,0-5.103,2.295-5.103,5.1v62.213c0,2.805,2.296,5.1,5.103,5.1h22.307C177.211,72.412,174.915,70.117,174.915,67.313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF5A50"
    },
    d: "M224.323,28.705h-36.966c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5h36.966V28.705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C73627"
    },
    d: "M354.286,0h-47.818c-2.807,0-6.538,1.791-8.292,3.98l-11.318,14.125 c0.514,0.804,0.817,1.76,0.817,2.788v30.624c0,1.028-0.304,1.985-0.817,2.789l11.318,14.127c1.754,2.188,5.485,3.979,8.292,3.979 h47.818c2.807,0,5.103-2.295,5.103-5.1V5.1C359.389,2.295,357.093,0,354.286,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF5A50"
    },
    d: "M324.383,28.705h-36.708v15h36.708c4.143,0,7.5-3.357,7.5-7.5S328.525,28.705,324.383,28.705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB786E"
    },
    d: "M288.675,51.517c0,2.805-2.296,5.1-5.102,5.1h-55.147c-2.806,0-5.103-2.295-5.103-5.1V20.893 c0-2.805,2.296-5.1,5.103-5.1h55.147c2.807,0,5.102,2.295,5.102,5.1V51.517z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.e860042aef5782cd9cb207f58a7c1298.svg";
export { ForwardRef as ReactComponent };